var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"primary","loading":_vm.publishLoading,"icon":"rollback"},on:{"click":_vm.toRevocationAnn}},[_vm._v("撤回官网公告\n")])}
var staticRenderFns = []

export { render, staticRenderFns }